"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionItem = SubscriptionItem;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _core = require("@material-ui/core");
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _Translations = require("react-platform-components/dist/Translations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _core.makeStyles)(function (theme) {
  var _paper;
  return {
    paper: (_paper = {
      flexDirection: 'column',
      maxWidth: '48rem',
      padding: '2.4rem',
      position: 'relative'
    }, _defineProperty(_paper, theme.breakpoints.down('md'), {
      maxWidth: 'none'
    }), _defineProperty(_paper, theme.breakpoints.down('sm'), {
      paddingBottom: '4.8rem',
      paddingTop: '4.8rem',
      paddingLeft: '4rem',
      paddingRight: '4rem'
    }), _paper),
    title: {
      fontSize: '2.2rem',
      fontWeight: '700',
      letterSpacing: '-.025em',
      lineHeight: '1.25',
      textAlign: 'center'
    },
    priceWrapper: {
      display: 'flex',
      alignItems: 'baseline',
      whiteSpace: 'nowrap',
      justifyContent: 'center'
    },
    priceText: {
      fontSize: '3rem',
      fontWeight: '600',
      lineHeight: '1.25',
      letterSpacing: '-.025em'
    },
    divider: {
      marginTop: '1rem',
      marginBottom: '1rem',
      borderRadius: '0.25rem',
      borderColor: 'rgb(226, 232, 240)',
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    deleteButtonIcon: {
      position: 'absolute',
      top: '14px',
      right: '14px',
      borderRadius: '31px',
      border: '1px solid',
      padding: '0',
      background: '#747474',
      color: '#fff',
      '&:hover': {
        background: '#505050'
      },
      '& .MuiSvgIcon-root': {
        fontSize: '22px'
      }
    }
  };
});
function SubscriptionItem(props) {
  var classes = useStyles();
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state.shoppingCartReducer;
    }),
    deleteItemInProgress = _useSelector.deleteItemInProgress;
  var cartItem = props.cartItem,
    onDelete = props.onDelete;
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 12,
    md: 6,
    lg: 6,
    xl: 4,
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Paper, {
    className: classes.paper
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    className: classes.deleteButtonIcon,
    onClick: onDelete,
    component: "span",
    disabled: deleteItemInProgress
  }, /*#__PURE__*/_react.default.createElement(_Close.default, null)), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.title
  }, cartItem.salable_item.salable_item_mxn_name), /*#__PURE__*/_react.default.createElement(_core.Divider, {
    className: classes.divider
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.priceWrapper
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.priceText
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlNumber, {
    value: cartItem.total_price,
    style: "currency",
    currency: "EUR"
  }))), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: "flex flex-col mt-8",
    color: "text.secondary"
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: cartItem.salable_item.description
    }
  }))));
}